var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from "react";
import { LazyLoad } from "@irati/utils/history/routing";
import domain from "@irati/utils/env/domain";
var Routes = /** @class */ (function (_super) {
    __extends(Routes, _super);
    function Routes() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Routes.prototype.render = function () {
        if (domain.isDev()) {
            return React.createElement(LazyLoad, { routes: function () { return import(/* webpackChunkName: "devTools" */ "./devTools"); } });
        }
        if (domain.isE2ESetupScripts()) {
            return React.createElement(LazyLoad, { routes: function () { return import(/* webpackChunkName: "e2eDevTools" */ "@irati/e2e/routes"); } });
        }
        if (domain.isInternal()) {
            return React.createElement(LazyLoad, { routes: function () { return import(/* webpackChunkName: "internal" */ "./internal"); } });
        }
        if (domain.isGlobal()) {
            return React.createElement(LazyLoad, { routes: function () { return import(/* webpackChunkName: "global" */ "./global"); } });
        }
        if (domain.isSandbox()) {
            return React.createElement(LazyLoad, { routes: function () { return import(/* webpackChunkName: "sandbox" */ "./sandbox"); } });
        }
        if (domain.isMerchant()) {
            return React.createElement(LazyLoad, { routes: function () { return import(/* webpackChunkName: "merchant" */ "./merchant"); } });
        }
        return React.createElement(LazyLoad, { routes: function () { return import(/* webpackChunkName: "tenant" */ "./tenant"); } });
    };
    return Routes;
}(Component));
export default Routes;
